<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('registrosHorarios')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change=" changeNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t('mes')}}</label>
                                <el-date-picker
                                        v-model="value1"
                                        type="month"
                                        format="MM-yyyy"
                                        :placeholder="$t('seleccionaUnaSemana')">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button @click="turnosOperarios()" class="btn btn-primary">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-12">

                <template v-if="list.length>0">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr style="cursor: pointer">
                                <th v-if="ordenacionOperario===0" @click="sortedArrayNameASC('workerName')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("nombre")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('workerName')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("nombre")}}
                                </th>
                                <th v-if="ordenarDifHora===0" @click="sortedArrayDifHoraASC('diffHora')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("horas")}}
                                </th>
                                <th v-else @click="sortedArrayDifHoraDESC('diffHora')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("horas")}}
                                </th>
                                <th>{{$t('acciones')}}</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="obj in list">
                                <td>
                                    <!--<el-checkbox v-model="obj.check">
                                    </el-checkbox>-->
                                    {{ obj.workerName}}
                                </td>
                                <td>{{obj.diffHora |timago }}</td>
                                <td>
                                    <div  v-tooltip.top-center="$t('exportarEnPDF')" class="btn btn-link" @click="exportTurnosOperariosPDF(obj.idWorker)"><i class="fas fa-file-pdf text-danger"></i></div>
                                    <div  v-tooltip.top-center="$t('exportarEnExcel')" class="btn btn-link" @click="exportTurnosOperariosExcel(obj.idWorker)"><i class="fas fa-file-excel text-success"></i></div>

                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td><strong v-if="getTotalHoras !==0">{{getTotalHoras |timago }}</strong></td>
                                <td></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorOperarios")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        CheckboxGroup,
        Checkbox
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", 'Registros horarios');
            this.getBusiness();


        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [CheckboxGroup.name]: CheckboxGroup,
            [Checkbox.name]: Checkbox,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                listBusinesses: [],
                value1: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                idBusiness: 0,
                list: [],

                ordenacionOperario: 0,
                ordenarImporte: 0,
                ordenarInvitations: 0,
                ordenarDifHora: 0,
                ordenarSueldo: 0,

                delayed: false

            }
        },
        computed: {
            getTotalSueldos() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount;

                });
                return total;
            },
            getTotalHoras() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.diffHora;

                });
                return total;
            },
            getTotalHorasWorker() {
                let total = 0;
                this.listTurnos.forEach(function (d) {

                    total += d.diffHora;

                });
                return total;
            },
            urlExportPDF() {
                return "../api/public/index.php/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("month").unix() + "&list=" + this.list[0] + "&dateto=" + moment(this.dateto).endOf("month").unix() + "&jwt=" + this.$store.getters.jwt

            },
            urlExportExcel() {
                /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
                 */
                return "../api/public/index.php/workers/exportTurnosWorkers/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },

        },
        methods: {

            sortedArrayNameASC: function () {
                this.ordenacionOperario = 1;

                function compare(a, b) {
                    if (a.workerName < b.workerName)
                        return -1;
                    if (a.workerName > b.workerName)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenacionOperario = 0;

                function compare(a, b) {

                    if (a.workerName > b.workerName)
                        return -1;
                    if (a.workerName < b.workerName)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayDifHoraASC: function () {
                this.ordenarDifHora = 1;

                function compare(a, b) {
                    if (a.diffHora < b.diffHora)
                        return -1;
                    if (a.diffHora > b.diffHora)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayDifHoraDESC: function () {
                this.ordenarDifHora = 0;

                function compare(a, b) {

                    if (a.diffHora > b.diffHora)
                        return -1;
                    if (a.diffHora < b.diffHora)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArraySueldoASC: function () {
                this.ordenarSueldo = 1;

                function compare(a, b) {
                    if (a.import < b.import)
                        return -1;
                    if (a.import > b.import)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArraySueldoDESC: function () {
                this.ordenarSueldo = 0;

                function compare(a, b) {

                    if (a.import > b.import)
                        return -1;
                    if (a.import < b.import)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.turnosOperarios();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            turnosOperarios() {


                if (this.value1 === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaValida'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let datefrom = moment(this.value1).startOf("month").unix();
                    let dateto = moment(this.value1).endOf("month").unix();


                    this.loading = true;


                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt,
                            datefrom: datefrom,
                            dateto: dateto,
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "workers/getRegistroHorarioByBusiness", config)
                        .then(function (response) {
                            if (response.data.response) {


                                vm.list = response.data.result;

                            }
                            else {
                                swal({
                                    title: vm.$t('accesoDenegado'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });


                            }
                            vm.loading = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                        });

                }

            },

            exportTurnosOperariosExcel(idWorker) {

                window.location.href = this.$store.getters.apiUrl+"/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.value1).startOf("month").unix() + "&idWorker=" + idWorker + "&dateto=" + moment(this.value1).endOf("month").unix() + "&jwt=" + this.$store.getters.jwt;


            },
            exportTurnosOperariosPDF(idWorker) {

                window.location.href = this.$store.getters.apiUrl+"/workers/exportRegistroHorarioByBusiness/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.value1).startOf("month").unix() + "&idWorker=" + idWorker + "&dateto=" + moment(this.value1).endOf("month").unix() + "&jwt=" + this.$store.getters.jwt;


            },

            changeNegocio() {

                this.list = [];

            },

        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/RegistrosHorarios.vue